import { createContext, useContext } from 'react'
import { Appointment, TaskListItem, TimeManagementListItem } from '@myapp/contract'
import { ResolvedBreak } from '../../../entities/time-entry/model/useBreakBlock'
import { GhostBlockInfo } from '../ui/TimelineTrack'
import type { LaneAssignment } from '../../../shared/lib/timeline/computeLanes'

interface TimelineRowDataContextValue {
  technicianId: string
  technicianName: string | null
  appointments: Appointment[]
  timeManagementEntries: TimeManagementListItem[]
  breakBlock: ResolvedBreak | null | undefined
  originalBreakBlock: ResolvedBreak | null | undefined
  ghostBlock: GhostBlockInfo | null
  isWorkingDay: boolean
  shiftStartHour?: number
  shiftEndHour?: number
  timedTasks: TaskListItem[]
  dayIso: string
  laneMap: ReadonlyMap<string, LaneAssignment>
  maxLaneCount: number
}

const TimelineRowDataContext = createContext<TimelineRowDataContextValue | null>(null)

export const TimelineRowDataProvider = TimelineRowDataContext.Provider

export function useTimelineRowData(): TimelineRowDataContextValue {
  const ctx = useContext(TimelineRowDataContext)
  if (!ctx) throw new Error('useTimelineRowData must be used inside TimelineRowDataProvider')
  return ctx
}
